import { setOptions } from '@googlemaps/js-api-loader';

let isInitialized = false;

export function initializeGoogleMaps() {
    if (!isInitialized) {
        setOptions({
            key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
            version: 'weekly',
        });
        isInitialized = true;
    }
}
